import { Box, Grid } from '@mui/material';
import { updatePaymentRequestPassiveObservation } from 'lib/api/paymentRequestPassives';
import { hasAnyPermissions, showAlert } from 'lib/functions/utils';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { AuthState } from 'services/redux/authSlice';

import ExportDialog from '../../../../../common/exportPaymentRequestPassive/components/ExportDialog';
import AmountSummary from './components/AmountSummary';
import DetailsSummary from './components/DetailsSummary';
import ObservationCard from './components/ObservationCard';
import { usePaymentStatus } from './hooks/usePaymentStatus';
import { PayOutSummaryProps } from './types';

const PayOutSummary: React.FC<PayOutSummaryProps> = ({ request }) => {
  const dispatch = useDispatch();
  const user = useSelector((state: { auth: AuthState }) => state.auth.user);
  const [openExportDialog, setOpenExportDialog] = useState(false);
  const [observation, setObservation] = useState<string>(
    request.observation || '',
  );

  useEffect(() => {
    setObservation(request.observation || '');
  }, [request.observation]);

  const hasCompletedPayments = usePaymentStatus(request);
  const canEditObservation = hasAnyPermissions(user, [
    'financing_payment_request_passive_update',
  ]);

  const handleSaveObservation = async (value: string) => {
    if (!request.id) return;
    try {
      await updatePaymentRequestPassiveObservation(dispatch, request.id, value);
      showAlert(dispatch, 'success', 'Observación actualizada correctamente');
    } catch (error) {
      console.error(error);
      showAlert(dispatch, 'error', 'Error al actualizar la observación');
      throw error;
    }
  };

  return (
    <Box sx={{ py: 1.5 }}>
      <Grid container spacing={2}>
        <Grid item xs={12} md={6}>
          <DetailsSummary request={request} />
        </Grid>
        <Grid
          item
          xs={12}
          md={6}
          sx={{
            position: 'relative',
            '&::before': {
              content: '""',
              position: 'absolute',
              left: 0,
              top: 0,
              bottom: 0,
              width: '1px',
              backgroundColor: 'divider',
              display: { xs: 'none', md: 'block' },
            },
          }}
        >
          <AmountSummary
            request={request}
            onExportClick={() => setOpenExportDialog(true)}
          />
        </Grid>
        <Grid item xs={12}>
          <ObservationCard
            observation={observation}
            onObservationChange={setObservation}
            onSave={handleSaveObservation}
            canEdit={canEditObservation}
          />
        </Grid>
      </Grid>
      <ExportDialog
        open={openExportDialog}
        setOpen={setOpenExportDialog}
        selectedRequest={request}
        canShowPayouts={hasCompletedPayments}
      />
    </Box>
  );
};

export default PayOutSummary;
